var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg-icon',{attrs:{"size":_vm.size,"actual-size":"384","color":_vm.color,"paths":_vm.paths}})}
var staticRenderFns = []

export { render, staticRenderFns }